import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as styles from './HeaderComponent.module.less';

const HamburgerIcon = ({ mobileNavVisible, setMobileNavVisible }) => {
  return (
    <div
      className={classNames(styles.hamburger, {
        [styles.isActive]: mobileNavVisible,
      })}
      onClick={() => setMobileNavVisible(!mobileNavVisible)}
    >
      <div className={styles.hamburgerBackground} />
      <a className={styles.hamburgerIcon}>
        <span className={classNames(styles.hamburgerLine, styles.line1)} />
        <span className={classNames(styles.hamburgerLine, styles.line2)} />
        <span className={classNames(styles.hamburgerLine, styles.line3)} />
      </a>
    </div>
  );
};

HamburgerIcon.propTypes = {
  mobileNavVisible: PropTypes.bool,
  setMobileNavVisible: PropTypes.function,
};

HamburgerIcon.defaultProps = {
  mobileNavVisible: false,
  setMobileNavVisible: null,
};

export default HamburgerIcon;
